import { render } from "./DetailViewDialog.vue?vue&type=template&id=0f8de440&scoped=true"
import script from "./DetailViewDialog.vue?vue&type=script&lang=ts"
export * from "./DetailViewDialog.vue?vue&type=script&lang=ts"

import "./DetailViewDialog.vue?vue&type=style&index=0&id=0f8de440&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f8de440"

export default script